import createModel from './lib/create_model';

var WebForm = createModel({
  modelName: 'WebForm',

  properties: {
    content: Object,
    submittedAt: String,
  },

  statics: {
    create(attrs) {
      return new this(attrs);
    },
  },
});

export default WebForm;



// WEBPACK FOOTER //
// ./src/scripts/domain/models/web_form.js